<template>
  <sAlert
    small
    type="warning">
    {{ $t('Automation.UncnownConditionType') }}
  </sAlert>
</template>
<script>
export default {
  name: 'emptyConditionParams',
  created() {
    const result = this.$_.cloneDeep(this.value)
    result.parameters = null
    this.$emit('update:value', result)
  },
  props: {
    value: {
      type: Object,
    },
    disabled: {
      type: Boolean
    },
    operators: {
      type: Array
    },
  },
}
</script>
